import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { COMMANDS } from '../utils/commonProperties';

const useEntitiesShow = (entities) => {
  const { commandType } = useSelector((state) => state.operation);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (commandType === COMMANDS.SHOW_ENTITIES) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [commandType]);

  return {
    showPopup,
    closePopup: () => setShowPopup(false),
    entities
  };
};

export default useEntitiesShow;
